import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { AppTooltip } from "../../../../../shared/components/AppTooltip";
import { MenuItem } from "../../../types";
import { FolderIconComponent } from "../FolderIconComponent";
import { ArrowIcon } from "../../../../../shared/icons/ArrowIcon";
import { isNotEmptyArray } from "../../../../../shared/utils/isNotEmptyArray";
import { SidebarItemIcon } from "../SidebarItemIcon";
import { APP_VECTOR_STORE_MODE } from "../../../../../services/api/constants";
import { StorageScope } from "../../../../../services/api/instances/storageApi/types/service_types";
import styles from "./styles.module.css";

interface Props {
  item: MenuItem;
  isFolder: boolean;
  isSelected: boolean;
  isFolderOpen: boolean;
  action: React.ReactNode;
  service: StorageScope;
  icon?: React.ReactElement;
  withoutActions?: boolean;
  className?: string;
}

export const SidebarItemContent = ({
  item,
  action,
  service,
  isFolder,
  isSelected,
  isFolderOpen,
  withoutActions,
  className,
}: Props) => {
  const [isLongItemName, setIsLongItemName] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState<boolean>(false);

  useEffect(() => {
    if (textRef.current) {
      const { scrollWidth, clientWidth } = textRef.current;
      setIsLongItemName(scrollWidth > clientWidth);
    }
  }, [item]);

  const itemCls = classNames(
    styles["sidebar-item"],
    item.parentId && styles["item-child"],
    isSelected && styles["sidebar-item-selected"],
    isSelected && item.parentId && styles["sidebar-child-selected"],
  );

  return (
    <AppTooltip
      classes={{ tooltip: styles["tooltip"] }}
      title={item.name}
      open={isHovering && isLongItemName}
      offsets={[-10, -5]}
    >
      <div
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className={itemCls}
      >
        <FolderIconComponent
          isFolderOpen={isFolderOpen ?? false}
          isFolder={isFolder}
        />
        {APP_VECTOR_STORE_MODE === "both" && (
          <SidebarItemIcon type={item.metadata?.itemType ?? "default"} />
        )}
        {item.isReceivedObject && <SidebarItemIcon type={"received_object"} />}
        {item.isSharedObject && <SidebarItemIcon type={"shared_object"} />}
        {item.readOnly && <SidebarItemIcon type={"read_only"} />}
        <div ref={textRef} className={styles["sidebar-item-name"]}>
          {item.name}
        </div>
        {!withoutActions && (
          <div className={styles["sidebar-item-action-container"]}>
            {isHovering && action}
            {isNotEmptyArray(item.children) && (
              <ArrowIcon
                className={classNames(
                  isFolderOpen && styles["arrow-icon-down"],
                )}
              />
            )}
          </div>
        )}
      </div>
    </AppTooltip>
  );
};
